import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgColorfulPdf({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      width={40}
      height={40}
      fill="none"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M4 14L18 0h16.5A1.5 1.5 0 0136 1.5v37a1.5 1.5 0 01-1.5 1.5h-29A1.5 1.5 0 014 38.5V14z"
        fill="#F56173"
      />
      <path d="M4 13.94L17.94 0v12.44a1.5 1.5 0 01-1.5 1.5H4z" fill="#D85860" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.635 20c.677 0 1.201.052 1.576.16a2.394 2.394 0 011.626 1.436c.143.353.214.747.214 1.182 0 .931-.292 1.65-.88 2.143-.58.485-1.427.723-2.536.723H10.24v2.232c0 .393-.097.705-.299.926a1.005 1.005 0 01-.768.334 1.01 1.01 0 01-.782-.332c-.197-.22-.291-.527-.291-.916v-6.622c0-.433.104-.758.327-.966.218-.204.545-.3.974-.3h2.233zm19.696 0c.323 0 .576.076.753.237a.823.823 0 01.267.631.83.83 0 01-.267.637c-.177.161-.43.237-.753.237h-3.228v1.797h2.665c.312 0 .557.074.73.23a.813.813 0 01.261.626.8.8 0 01-.267.625c-.173.153-.417.226-.724.226h-2.665v2.63c0 .405-.096.72-.297.936-.2.215-.462.324-.77.324-.313 0-.576-.11-.777-.328-.2-.217-.296-.53-.296-.932v-6.61c0-.277.042-.51.13-.697a.89.89 0 01.447-.442c.187-.086.416-.127.69-.127h4.1zm-9.58.17c-.44-.114-.962-.17-1.568-.17h-2.267c-.424 0-.745.1-.956.31-.211.212-.31.533-.31.956v6.3c0 .293.026.536.08.73.063.224.2.4.404.522.196.117.468.172.817.172h2.268c.404 0 .77-.026 1.095-.079.332-.053.643-.146.933-.28a3.18 3.18 0 00.806-.53c.311-.286.565-.609.763-.97a4.37 4.37 0 00.436-1.206c.093-.44.14-.925.14-1.454 0-1.616-.47-2.837-1.412-3.644a2.987 2.987 0 00-1.229-.657zm-2.013 1.607h-.948v5.43l1.28-.001.28-.007.22-.015c.146-.014.3-.049.46-.106.153-.054.283-.13.396-.228.53-.448.802-1.24.802-2.39 0-.815-.121-1.416-.355-1.8-.232-.383-.509-.62-.834-.72a4.135 4.135 0 00-1.05-.159l-.25-.004zm-9.497-.07h.972l.21.003c.61.02 1.006.133 1.189.318.182.196.276.455.276.785 0 .276-.06.49-.178.649a1 1 0 01-.528.35c-.254.079-.578.12-.969.12h-.972v-2.226z"
        fill="#fff"
      />
    </svg>
  );
}

SvgColorfulPdf.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgColorfulPdf.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgColorfulPdf svgRef={ref} {...props} />);
export default ForwardRef;
